// FILTER index
import mutations from './mutations';
import actions from './actions';
import getters from './getters';

export default {
  state: {
    // SIDEBAR STATE
    search: '',
    sidebar: {
      isOpened: false,
    },
    // FILTER MENU FROM API
    // filtersMenu: [],
    // APP STATE
    tableName: '',
    tableActions: '',
    customName: false,
    isNewFilter: false,
    // activeFilter: {},
    // activeTmpFilter: {},
    activeFilterName: 'All',
    // filterFields: [],
    // temporaryFields: [],
    // NEW DATA
    tableApi: '',
    sidebarTableApi: '',
    sidebarFields: [],
    filtersMenu: [],
    activeFilter: {},
    allShipmentSearchQuery: '',
    dataNotFound: false,
  },
  actions,
  mutations,
  getters,
};
